import offersIcon from "../../assets/offers-icon.png";
import dashboardIcon from "../../assets/dashboard-icon.png";
import ordersIcon from "../../assets/orders-icon.png";
import billingIcon from "../../assets/billing-icon.png";
import { ClipboardList, BarChart3 } from "lucide-react";

const withImageIcon = (src, alt) => {
  const ImageIcon = ({ size = 25, className, isActive = false, ...props }) => (
    <img
      src={src}
      width={size}
      height={size}
      alt={alt}
      style={isActive ? { filter: "brightness(0) invert(1)" } : undefined}
      className={`object-contain ${className || ""}`.trim()}
      {...props}
    />
  );

  ImageIcon.displayName = `${alt.replace(/\s+/g, "")}NavIcon`;
  return ImageIcon;
};

export const DashboardNavIcon = withImageIcon(dashboardIcon, "Dashboard");
export const OffersNavIcon = withImageIcon(offersIcon, "Offers");
export const OrdersNavIcon = withImageIcon(ordersIcon, "Orders");
export const BillingNavIcon = withImageIcon(billingIcon, "Billing");
export const ReportsNavIcon = ({ size = 25, className, isActive = false, ...props }) => (
  <BarChart3
    size={size}
    strokeWidth={2.25}
    className={`transition-all duration-200 ease-out ${isActive ? "text-white" : ""} ${className || ""}`.trim()}
    aria-hidden="true"
    {...props}
  />
);

export const OrdersDevNavIcon = ({ size = 25, className, isActive = false, ...props }) => (
  <ClipboardList
    size={size}
    strokeWidth={2.25}
    className={`transition-all duration-200 ease-out ${isActive ? "text-white" : ""} ${className || ""}`.trim()}
    aria-hidden="true"
    {...props}
  />
);
